module.exports = __webpack_public_path__ + "img/permission_denied.c8792af2.svg";